module.exports = __webpack_public_path__ + "static/media/add-button-icon.040345a5.svg";